export default __webpack_public_path__ + "static/media/S3xCLUE3.b4540780.jpg";